import React, { useEffect, useState } from "react";
import './ProgramacionDeServicio.scss'
import { DataTable } from "primereact/datatable";
import InputText from "../../../components/atoms/InputText/InputText";
import { Column } from "primereact/column";
import { isoAUtc } from "../../../utilities/formateos";


const ProgramacionDeServiciosTabla = ({data=[]})=>
{
    const [globalFilter, setGlobalFilter] = useState('');
    useEffect(()=>{
        if(globalFilter =='activo' ||globalFilter =='activos')
        {
            setGlobalFilter(false)
        }
        if(globalFilter=='cancelado'||globalFilter=='cancelados')
        {
            setGlobalFilter(true)
        }
    },[globalFilter])
 
    
    return(
        <div className="ProgramacionDeServiciosTabla">
            <InputText title="" placeholder={"Buscar"} onChange={(e)=>{setGlobalFilter(e.target.value)}}></InputText>
            <div>Total : {data.length}</div>
             <DataTable
                value={data}
                globalFilter={globalFilter}
                paginator
                rowsPerPageOptions={[5,10,15,20,40,80]}
                paginatorTemplate="PrevPageLink PageLinks NextPageLink"
                rows ={10} 

            >
                <Column field="ID_TR_BITACORA" header="Bitácora" body={(rowData) => <td className="tablaCampo" data-label="ID_TR_BITACORA">{rowData.ID_TR_BITACORA}</td>}/>
                <Column field="FECHA" header="Fecha" body={(rowData) => <td className="tablaCampo" data-label="FECHA">{isoAUtc(rowData.FECHA) }</td>} />
                <Column field="NOMBRE_CONDUCTOR" header="Operador" body={(rowData) => <td className="tablaCampo" data-label="NOMBRE_CONDUCTOR">{rowData.NOMBRE_CONDUCTOR}</td>}/>
                <Column field="NOMBRE_TR_RUTA" header="Ruta" body={(rowData) => <td className="tablaCampo" data-label="NOMBRE_TR_RUTA">{rowData.NOMBRE_TR_RUTA}</td>}/>
                <Column field="TIPO_TR_BITACORA" header="Tipo" body={(rowData) => <td className="tablaCampo" data-label="TIPO_TR_BITACORA">{rowData.TIPO_TR_BITACORA}</td>}/>
                <Column field="CANCELADO" header="A/C" body={(rowData) => <td className="tablaCampo" data-label="CANCELADO">{rowData.CANCELADO?<div className="cancelado">Cancelado</div>: <div className="activo">Activo</div> }</td>}/>
            </DataTable>
        </div>
    )
}
export default ProgramacionDeServiciosTabla